export const Web_3_Object = "Web_3_Object";
export const WEB_3_CONNECTED = "WEB_3_CONNECTED";

export const SET_META_MASK_ADDRESS = "SET_META_MASK_ADDRESS";
export const DELETE_META_MASK_ADDRESS = "DELETE_META_MASK_ADDRESS";

export const SET_TOKEN_STATS = "SET_TOKEN_STATS";
export const DELETE_TOKEN_STATS = "DELETE_TOKEN_STATS";
